import { useTranslation } from "react-i18next"

import i18n from "../locales/i18n"

/**
 * Joon coaches only speak English, so every entrypoint into the coaching purchase
 * funnel is hidden when the app is displaying in another language.
 *
 * We read `resolvedLanguage` — the language i18next actually settled on — rather than
 * the raw browser locale. Someone whose browser is set to a language we don't ship
 * (Italian, say) falls back to the English bundle, and if they're still using the app
 * they can understand a coach too, so they keep seeing coaching.
 */
export const isCoachingAvailable = () => i18n.resolvedLanguage === "en"

/**
 * Render-time version of {@link isCoachingAvailable}. Goes through `useTranslation` so
 * components re-render when the settings language picker switches language mid-session.
 */
const useIsCoachingAvailable = () => {
  const { i18n } = useTranslation()
  return i18n.resolvedLanguage === "en"
}

export default useIsCoachingAvailable
